<template>
  <div>
    <mc-side-bar>
      <nav class="mds-tree-nav" role="navigation" aria-label="side navigation">
        <ul>
          <!-- Bowler Charts Collection -->
          <li>
            <a
                href="#"
                :class="{ 'mds-tree-nav__active': isActiveRoute('/') }"
                :aria-current="isActiveRoute('/') ? 'page' : null"
                @click.prevent="handleMenuClick('BowlerChartCollection')"
            >
              <mc-icon icon="house"></mc-icon>
              <span>Bowler Charts Collection</span>
            </a>
          </li>

          <!-- Product Management -->
          <li>
            <details open>
              <summary>Product Management</summary>

              <template
                  v-for="(menu, i) in filteredNav.filter(
                menu => menu.label === 'Product Management'
            )"
                  :key="i"
              >
                <ul>
                  <li v-for="(child, j) in menu.children" :key="j">
                    <a
                        href="#"
                        :class="{ 'mds-tree-nav__active': isActiveRoute(child.to) }"
                        :aria-current="isActiveRoute(child.to) ? 'page' : null"
                        @click.prevent="handleMenuClick(child.group)"
                    >
                      <mc-icon :icon="child.icon"></mc-icon>
                      <span>{{ child.label }}</span>
                    </a>
                  </li>
                </ul>
              </template>
            </details>
          </li>

          <li class="mds-tree-nav--separator"></li>

          <!-- Available Bowler Charts -->
          <li>
            <a href="#">Available Bowler Charts</a>
          </li>

          <!-- Search -->
          <li>
            <div class="px-2 pb-2">
              <mc-input
                  label="Search Bowler Charts"
                  hiddenlabel
                  fit="small"
                  icon="magnifying-glass"
                  trailingicon="magnifying-glass"
                  placeholder="Search Bowler Charts"
                  :value.prop="menuSearch"
                  @input="menuSearchHandler"
              >
              </mc-input>
            </div>
          </li>
        </ul>

        <!-- Bowler Charts -->
        <ul>
          <li v-for="product in filteredProducts" :key="product.productId">
            <details :open="isActiveProduct(product.productId)">
              <summary
                  :class="{
              'mds-tree-nav__active': isActiveProduct(product.productId)
            }"
              >
                {{ product.productName }}
              </summary>

              <ul>
                <!-- Dashboard -->
                <li>
                  <a
                      href="#"
                      :class="{
                  'mds-tree-nav__active':
                    isActiveMenu(product.productId, 'dashboard')
                }"
                      :aria-current="
                  isActiveMenu(product.productId, 'dashboard')
                    ? 'page'
                    : null
                "
                      @click.prevent="selectMenu(product, 'dashboard')"
                  >
                    <mc-icon icon="house"></mc-icon>
                    <span>Dashboard</span>
                  </a>
                </li>

                <!-- Manage Users -->
                <li v-if="product.accessRestrictionEnabled">
                  <a
                      href="#"
                      :class="{
                  'mds-tree-nav__active':
                    isActiveMenu(product.productId, 'users')
                }"
                      :aria-current="
                  isActiveMenu(product.productId, 'users')
                    ? 'page'
                    : null
                "
                      @click.prevent="selectMenu(product, 'users')"
                  >
                    <mc-icon icon="user-cog"></mc-icon>
                    <span>Manage Users</span>
                  </a>
                </li>

                <!-- Add Owners -->
                <li>
                  <a
                      href="#"
                      :class="{
                  'mds-tree-nav__active':
                    isActiveMenu(product.productId, 'owners')
                }"
                      :aria-current="
                  isActiveMenu(product.productId, 'owners')
                    ? 'page'
                    : null
                "
                      @click.prevent="selectMenu(product, 'owners')"
                  >
                    <mc-icon icon="user-plus-circle"></mc-icon>
                    <span>Add Owners</span>
                  </a>
                </li>
              </ul>
            </details>
          </li>
        </ul>
      </nav>
    </mc-side-bar>
  </div>
</template>

<script>
import '@maersk-global/mds-components-core-accordion';
import '@maersk-global/mds-components-core-accordion-item';
import "@maersk-global/mds-components-core/mc-icon";
import "@maersk-global/mds-design-tokens/maersk/light/css/design-tokens-px.css";
import "@maersk-global/mds-foundations/css/foundations.css";
import "@maersk-global/mds-components-core-top-bar";
import "@maersk-global/mds-components-core-side-bar";
import '@maersk-global/mds-components-core-list';
import '@maersk-global/mds-components-core-list-item';
import { avLnsActions } from "@/actions";
import AxiosFetchForMsal from "@/utils/axiosForMsal";

export default {
  name: "NavBar",
  data() {
    return {
      mainSidebarDrawer: true,
      products: [],
      menuSearch: "",
      activeProduct: sessionStorage.getItem("activeProduct"),
      activeMenu: sessionStorage.getItem("activeMenu")
    };
  },

  computed: {
    filteredProducts() {
      return this.products.filter(product =>
          !this.menuSearch ||
          product.productName
              .toLowerCase()
              .includes(this.menuSearch.toLowerCase())
      );
    },
    filteredNav() {
      return this.getNav
          .map(menu => {
            const children = (menu.children || []).filter(
                c =>
                    c.shouldBeVisible &&
                    (!c.onlyFor)
            );

            return {
              ...menu,
              children
            };
          })
          .filter(menu => menu.shouldBeVisible);
    },

    getNav() {
      return [
        {
          label: "Bowler Charts Collection",
          icon: "house",
          group: "BowlerChartCollection",
          shouldBeVisible: true,
        },
        {
          label: "Product Management",
          icon: "layout-2x2",
          group: "BOWLERCHART",
          shouldBeVisible: true,
          children: [
            {
              to: "/Connect",
              label: "Onboard Product",
              icon: "link",
              group: "Connect",
              shouldBeVisible: true
            },
            {
              to: "/edit-product",
              label: "Manage Products",
              icon: "clipboard-cog-text",
              group: "ProductConfiguration",
              shouldBeVisible: true
            },
            {
              to: "/feedback",
              label: "User Feedback",
              icon: "user-text-rectangle",
              group: "UserFeedback",
              shouldBeVisible: true
            },
          ]
        },
        {
          label: "Bowler chart",
          icon: "house",
          group: "BOWLERCHART",
          shouldBeVisible: true,
          children: this.products
              .filter(product =>
                  !this.menuSearch ||
                  product.productName
                      ?.toLowerCase()
                      .includes(this.menuSearch.toLowerCase())
              )
              .map(product => ({
            label: product.productName,
            icon: "house",
            group: product.productId,
            shouldBeVisible: true,
            children: [
              {
                to: {
                  name: 'RegisteredApplication',
                  params: { productId: product.productId },
                  state: {
                    productName: product.productName,
                    productDescription: product.productDescription,
                    productCreatedBy: product.productCreatedBy,
                    fbpOwner: product.fbpOwner,
                  }
                },
                label: 'Dashboard',
                icon: "house",
                group: product.productId,
                shouldBeVisible: true
              },
              {
                to: {
                  name: 'UserPage',
                  params: { productId: product.productId },
                  state: {
                    productName: product.productName,
                    productDescription: product.productDescription,
                    productCreatedBy: product.productCreatedBy,
                    fbpOwner: product.fbpOwner,
                  }
                },
                label: 'Manage Users',
                icon: "users",
                group: product.productId,
                shouldBeVisible: product.accessRestrictionEnabled === true
              },
              {
                to: {
                  name: 'OwnerPage',
                  params: { productId: product.productId },
                  state: {
                    productName: product.productName,
                    productDescription: product.productDescription,
                    productCreatedBy: product.productCreatedBy,
                    fbpOwner: product.fbpOwner,
                  }
                },
                label: 'Add Owners',
                icon: "user-plus-circle",
                group: product.productId,
                shouldBeVisible: true
              }
            ]
          }))
        }
      ];
    }
  },
  mounted() {
    const token = sessionStorage.getItem("av_msal_token");
    if (token) {
      this.loadProductDetails();
    }
  },
  watch: {
    '$route'(to, from) {
      const productId = to.params?.productId;
      if (productId && (productId !== from.params?.productId || to.name !== from.name)) {
        sessionStorage.setItem("currentProductId", productId);
        // ✅ Only call fetchUserAccess if this product has accessRestrictionEnabled === true
        const product = this.products.find(p => p.productId === productId);
        if (product?.accessRestrictionEnabled === true  && to.name !== 'OwnerPage') {
          this.fetchUserAccess(productId);
        }
      }
    },
  },
  methods: {
    selectMenu(product, menu) {
      this.activeProduct = product.productId;
      this.activeMenu = menu;

      sessionStorage.setItem("activeProduct", product.productId);
      sessionStorage.setItem("activeMenu", menu);

      if (menu === "dashboard") {
        this.goToDashboard(product);
      } else if (menu === "users") {
        this.goToUsers(product);
      } else {
        this.goToOwners(product);
      }
    },

    isActiveProduct(productId) {
      return this.activeProduct === productId;
    },

    isActiveMenu(productId, menu) {
      return this.activeProduct === productId && this.activeMenu === menu;
    },
    goToDashboard(product) {
      const userEmail = (sessionStorage.getItem("userEmail") || "").trim().toLowerCase();

      const createdBy = (product.productCreatedBy || "").trim().toLowerCase();

      const delegateAccess = (product.delegateUsers || [])
          .map(e => (e || "").trim().toLowerCase());

      // Restrict only when access restriction is enabled
      if (
          product.accessRestrictionEnabled === true &&
          userEmail !== createdBy &&
          !delegateAccess.includes(userEmail)
      ) {
        sessionStorage.setItem("unauthorizedAccess", "true");

        this.$router.push({
          path: "/unauthorized",
          query: { productId: product.productId }
        });

        return;
      }

      this.$router.push({
        name: "RegisteredApplication",
        params: { productId: product.productId },
        state: {
          productName: product.productName,
          productDescription: product.productDescription,
          productCreatedBy: product.productCreatedBy,
          fbpOwner: product.fbpOwner,
        }
      });
    },
    goToUsers(product) {
      this.$router.push({
        name: "UserPage",
        params: { productId: product.productId },
        state: {
          productName: product.productName,
          productDescription: product.productDescription,
          productCreatedBy: product.productCreatedBy,
          fbpOwner: product.fbpOwner,
        }
      });
    },

    goToOwners(product) {
      const userEmail = (sessionStorage.getItem("userEmail") || "").trim().toLowerCase();
      const createdBy = (product.productCreatedBy || "").trim().toLowerCase();
      const delegateAccess = (product.delegateUsers || []).map(e => (e || "").trim().toLowerCase());

      const isAuthorized = !!userEmail && (createdBy === userEmail || delegateAccess.includes(userEmail));

      if (!isAuthorized) {
        sessionStorage.setItem("unauthorizedAccess", "true");
        this.$router.push({ path: '/unauthorized', query: { productId: product.productId } });
        return;
      }
      this.$router.push({
        name: "OwnerPage",
        params: { productId: product.productId },
        state: {
          productName: product.productName,
          productDescription: product.productDescription,
          productCreatedBy: product.productCreatedBy,
          fbpOwner: product.fbpOwner,
        }
      });
    },
    menuSearchHandler(event){
      this.menuSearch = event.target.value;
    },
    async loadProductDetails(){
      this.loadAllProducts = false;
      const accessTokenCheck = JSON.parse(sessionStorage.getItem("av_msal_token"));
      const options = await avLnsActions.getProductListDetails(
          accessTokenCheck.idToken
      );
      const response = await AxiosFetchForMsal(options);
      // ✅ must add this
      if (!response || response.error) return;

      if (response.status === 200) {
        this.products = response.data || [];
        sessionStorage.setItem("products", JSON.stringify(this.products));
        this.loadAllProducts = true;
      }
    },

    isActiveRoute(to) {
      if (!to) return false;
      if (typeof to === 'string') return this.$route.path === to;
      if (to.params?.productId) {
        return this.$route.params?.productId === to.params.productId &&
            this.$route.name === to.name;
      }
      return false;
    },
    handleMenuClick(group) {
      this.activeProduct = null;
      this.activeMenu = null;
      sessionStorage.setItem("productCreatedBy", '');
      sessionStorage.setItem("fbpOwner", '');
      sessionStorage.setItem("activeMenu", '');
      sessionStorage.setItem("activeProduct", '');
      this.$router.push({
        name: group,
        params: { productId: '' },
        state: {
          productName: '',
          productDescription: '',
          productCreatedBy: '',
          fbpOwner: '',
        }
      });
    },
    async fetchUserAccess(productId) {
      try {
        const idToken = JSON.parse(sessionStorage.getItem("av_msal_token"))?.idToken;
        const userEmail = sessionStorage.getItem("userEmail");
        if (!idToken || !userEmail || !productId) return;
        const options = await avLnsActions.retrieveUserAccessDetails(
            { productId, userEmail },
            idToken
        );
        const response = await AxiosFetchForMsal(options);
        if (response?.status === 200) {
          sessionStorage.setItem("userAccessDetails", JSON.stringify(response.data));
        }
      } catch (e) {
        console.error("Failed to fetch user access:", e);
      }
    }
   }
};
</script>

<style scoped>
.v-navigation-drawer {
  box-shadow: 1px 1px 6px rgb(0 0 0 / 25%);
  position: fixed;
  top: 64px !important;
}

.v-list-item-title {
  white-space: nowrap;
}
</style>


